import { gql } from '@apollo/client';

export const UPDATE_QUIZ_SCORE = gql`
  mutation updateQuizScore($user_idx: Int!,$idx: Int!,$score: Int!, $user_answer : String) {
    updateQuizScore(user_idx: $user_idx, idx: $idx, score : $score, user_answer: $user_answer)
  }
`;